import { SVGProps } from 'react';

export const IconCheck = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='0 0 14 10'>
      <path
        d='m1 3.68 4.543 4.626a1 1 0 0 0 1.485-.064L13 1'
        stroke='currentColor'
        strokeWidth='2'
        fill='none'
        fillRule='evenodd'
      />
    </svg>
  );
};
